import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs/Observable';
import { publishReplay, refCount } from 'rxjs/operators';
import { Education } from '../../models/customer.model';
import { HttpClientService } from '../httpClient/httpclient.service';


@Injectable()
export class EducationService {

  private baseUrl = 'koncentro-customers';
  educations: Education[];
  educationEditing: Education;
  private cachedFields: Observable<any>;

  constructor(
    private httpClient: HttpClientService,
    private messageService: MessageService
  ) { }

  getList() {
    return this.httpClient.get(`/${this.baseUrl}/educations`)
      .map(res => {
        return this.educations = res;
      });
  }

  delete(record) {
    return this.httpClient.delete(`/${this.baseUrl}/educations/` + record.id)
      .map(res => {
        this.educations.splice(this.educations.indexOf(record), 1);
        this.messageService.add({severity: 'info', summary: 'Confirmed', detail: 'Education deleted'});
      });
  }

  post(newData) {
    return this.httpClient.post(`/${this.baseUrl}/educations`, newData)
      .map(res => {
        newData.id = res.id;
        this.educations.push(newData);
        this.messageService.add({severity: 'info', summary: 'Confirmed', detail: 'Education added'});
      });
  }

  put(newData, id) {
    let oldData = this.educations.find((education) => education.id === id);
    return this.httpClient.put(`/${this.baseUrl}/educations/` + id, newData)
      .map(res => {
        Object.assign(oldData, newData);
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.httpClient.get('/koncentro-customers/schema/EducationDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/education/education.service.ts